import { render } from "./LicenseForm.vue?vue&type=template&id=cc49f4e6&scoped=true"
import script from "./LicenseForm.vue?vue&type=script&lang=js"
export * from "./LicenseForm.vue?vue&type=script&lang=js"

import "./LicenseForm.vue?vue&type=style&index=0&id=cc49f4e6&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc49f4e6"]])

export default __exports__